import { cn } from "@utils/tailwind.util";
import { BounceBar } from "@ui/Loaders";

interface AIContextSkeletonProps {
  className?: string;
}

export function AIContextSkeleton({ className }: AIContextSkeletonProps) {
  return (
    <div className={cn("flex flex-col gap-3", className)}>
      <BounceBar className="h-3 rounded-2xl" />
      <BounceBar className="h-3 rounded-2xl" />
      <BounceBar className="h-3 rounded-2xl" />
      <BounceBar className="h-3 rounded-2xl" />
      <BounceBar className="h-3 w-[150px] rounded-2xl" />
    </div>
  );
}
